import posthog from 'posthog-js'

export function initPostHog(): typeof posthog | null {
  const token = import.meta.env.VITE_POSTHOG_TOKEN
  const host = import.meta.env.VITE_POSTHOG_HOST
  if (!token || !host) {
    return null
  }

  posthog.init(token, {
    api_host: host,
    defaults: '2026-01-30',
    disable_session_recording: true,
    capture_pageview: false,
    capture_pageleave: true,
  })
  posthog.register({
    environment: import.meta.env.VITE_POSTHOG_ENVIRONMENT ?? import.meta.env.MODE,
  })
  return posthog
}

export { posthog }
